import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts'

interface ProjectStatusData {
  name: string
  value: number
  color: string
}

interface ProjectStatusChartProps {
  data: ProjectStatusData[]
  description?: string
}

export function ProjectStatusChart({ data, description }: ProjectStatusChartProps) {
  const total = data.reduce((sum, d) => sum + d.value, 0)
  const hasData = total > 0

  return (
    <div className="bg-white p-6 rounded-xl border-2 border-[#bcccdc] shadow-lg">
      <div className="flex items-center justify-between mb-4 pb-3 border-b-2 border-[#f0f4f8]">
        <h2 className="text-lg text-[#102a43]">Project Status Distribution</h2>
        <button className="text-[#486581] hover:text-[#102a43] text-sm font-medium">
          View Details →
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-[#f0f4f8] p-4 rounded-lg flex items-center justify-center" style={{ minHeight: 280 }}>
          {hasData ? (
            <ResponsiveContainer width="100%" height={280}>
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ name, value }) => `${name}: ${value}`}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <div className="text-center text-[#829ab1]">
              <div className="w-20 h-20 rounded-full border-4 border-[#bcccdc] mx-auto mb-3 flex items-center justify-center">
                <span className="text-2xl font-light text-[#bcccdc]">0</span>
              </div>
              <p className="text-sm">No project data available</p>
            </div>
          )}
        </div>
        <div className="flex flex-col justify-center space-y-4">
          {description && (
            <div className="p-4 bg-[#f0f4f8] rounded-lg border-l-4 border-green-500">
              <p className="text-sm text-[#486581]">{description}</p>
            </div>
          )}
          {data.map((item, index) => (
            <div
              key={index}
              className="p-4 bg-[#f0f4f8] rounded-lg border-l-4"
              style={{ borderColor: item.color }}
            >
              <p className="text-sm text-[#486581]">
                {item.name}: {item.value} projects
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

